// ルームタイプ（3パターン）
export type RoomType = 'business' | 'dating' | 'job'

export const ROOM_TYPE_LABELS: Record<RoomType, string> = {
  business: 'ビジネス交流会',
  dating: '婚活',
  job: '転職・就職',
}

// 性別
export type Gender = 'male' | 'female' | 'other'

export const GENDER_LABELS: Record<Gender, string> = {
  male: '男性',
  female: '女性',
  other: 'その他',
}

// ルームサブ情報（プロフィール詳細に表示）
export interface RoomSubInfoItem {
  roomSubInfoId: string
  propertyName: string
  propertyType: string
  subValue: string
}

// 基本プロフィール（共通）
export interface BaseProfile {
  id: string
  name: string
  photoUrl?: string
  contactEmail?: string
  contactPhone?: string
  createdAt: Date
  subInfos?: RoomSubInfoItem[]
  /** ルームの主催者(管理者)かどうか。参加者一覧での表示に使う */
  isRoomOwner?: boolean
}

// ビジネス交流会プロフィール
export interface BusinessProfile extends BaseProfile {
  type: 'business'
  companyName: string
  position: string
  businessContent: string
  pr?: string
  comment?: string
  wantToMatch?: string
  notWantToMatch?: string
}

// 婚活プロフィール
export interface DatingProfile extends BaseProfile {
  type: 'dating'
  age: number
  occupation: string
  gender: Gender
  annualIncome: string
  wantChildren?: string
  pr?: string
  wantToMatch?: string
  notWantToMatch?: string
  userNumber: string
}

// 転職・就職プロフィール
export interface JobProfile extends BaseProfile {
  type: 'job'
  companyName?: string
  lastPosition: string
  education: string
  schoolName: string
  age?: number
  gender?: Gender
  pr?: string
  comment?: string
  wantToMatch?: string
  notWantToMatch?: string
}

// ユニオン型
export type Profile = BusinessProfile | DatingProfile | JobProfile

// プロフィール入力フォーム用の型
export interface BusinessProfileForm {
  name: string
  companyName: string
  position: string
  businessContent: string
  pr: string
  comment: string
  wantToMatch: string
  notWantToMatch: string
  contactEmail: string
  contactPhone: string
  photoUrl: string
}

export interface DatingProfileForm {
  name: string
  age: string
  occupation: string
  gender: Gender | ''
  annualIncome: string
  wantChildren: string
  pr: string
  wantToMatch: string
  notWantToMatch: string
  contactEmail: string
  contactPhone: string
  photoUrl: string
}

export interface JobProfileForm {
  name: string
  companyName: string
  lastPosition: string
  education: string
  schoolName: string
  age: string
  gender: Gender | ''
  pr: string
  comment: string
  wantToMatch: string
  notWantToMatch: string
  contactEmail: string
  contactPhone: string
  photoUrl: string
}

// ルーム情報
export interface Room {
  id: string
  name: string
  type: RoomType
  canEdit?: boolean
  description?: string
  eventDate?: Date
  expiresAt?: Date
  password?: string
  maxParticipants?: number
  createdAt: Date
  participants: Profile[]
}
